import React, { useEffect, useState } from "react";
import "./Carousel.css";
import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import Image from "../Reusable/Image";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import ApiConstants from "../../Utils/ApiConstant";

gsap.registerPlugin(MotionPathPlugin);

const Carousel = ({ data }) => {

  const [feedback, setFeedback] = useState(data[0].feedback)

  useEffect(() => {
    const circlePath = MotionPathPlugin.convertToPath("#holder", false)[0];
    circlePath.id = "circlePath";
    document.querySelector("svg").prepend(circlePath);

    let items = gsap.utils.toArray(".item");
    let numItems = items.length;
    let itemStep = 1 / numItems;
    let wrapProgress = gsap.utils.wrap(0, 1);
    let snap = gsap.utils.snap(itemStep);
    let wrapTracker = gsap.utils.wrap(0, numItems);
    let tracker = { item: 0 };

    gsap.set(items, {
      motionPath: {
        path: circlePath,
        align: circlePath,
        alignOrigin: [0.5, 0.5],
        end: (i) => gsap.utils.wrap(0, 1, i / items.length + 0.25),
      },
      scale: 0.9,
    });

    const tl = gsap.timeline({ paused: true, reversed: true });

    tl.to(".wrapper", {
      rotation: 360,
      transformOrigin: "center",
      duration: 1,
      ease: "none",
    });

    tl.to(
      items,
      {
        rotation: "-=360",
        transformOrigin: "center center",
        duration: 1,
        ease: "none",
      },
      0
    );

    tl.to(
      tracker,
      {
        item: numItems,
        duration: 1,
        ease: "none",
        modifiers: {
          item: (value) => wrapTracker(numItems - Math.round(value)),
        },
      },
      0
    );

    items.forEach((el, i) => {
      el.addEventListener("click", function () {
        var current = tracker.item;
        var activeItem = i;

        if (i === current) {
          return;
        }

        document.querySelector(".item.active").classList.remove("active");
        items[activeItem].classList.add("active");

        var diff = current - i;

        if (Math.abs(diff) < numItems / 2) {
          moveWheel(diff * itemStep);
        } else {
          var amt = numItems - Math.abs(diff);

          if (current > i) {
            moveWheel(amt * -itemStep);
          } else {
            moveWheel(amt * itemStep);
          }
        }
      });
    });

    document.getElementById("next").addEventListener("click", function () {
      return moveWheel(-itemStep);
    });

    document.getElementById("prev").addEventListener("click", function () {
      return moveWheel(itemStep);
    });

    function moveWheel(amount) {
      let progress = tl.progress();
      tl.progress(wrapProgress(snap(tl.progress() + amount)));
      let next = tracker.item;
      tl.progress(progress);

      document.querySelector(".item.active").classList.remove("active");
      items[next].classList.add("active");
      setFeedback(data[next]?.feedback ?? "");

      gsap.to(tl, {
        progress: snap(tl.progress() + amount),
        modifiers: {
          progress: wrapProgress,
        },
      });
    }
  }, []);

  return (
    <div>
      <div className="container">
        <div className="wrapper">
          {data
            .map((item, index) => (
              <div key={index} className={`item ${index === 0 ? "active" : ""} d-flex flex-column gap-3`}>
                <Image
                  src={item.userImage ? ApiConstants.FILE_FETCH_URL + item.userImage : PngImages.testimonialImage}
                  style={{ width: "100%", borderRadius: 10, aspectRatio: 1, objectFit: "cover" }}
                />
                <div className="d-flex flex-column gap-1 align-items-center">
                  <h3 className="medium-text black mb-0 fw-500 text-center">  
                    {item.name}
                  </h3>
                  <h3 className="medium-text black mb-0 fw-600 text-center">
                    {item.designation}
                  </h3>
                </div>
              </div>
            ))}

          <svg viewBox="0 0 300 300">
            <circle id="holder" className="st0" cx="151" cy="151" r="150" />
          </svg>
        </div>
      </div>
      <p className="medium-text subTextColor my-3 text-center mx-4">
        {feedback}
      </p>
      <div
        className="container d-flex gap-3 justify-content-center"
        style={{ textAlign: "center" }}>
        <button id="next" className="sliderButtons">
          <Image src={SvgImages.rightArrow} style={{ rotate: "180deg" }} />
        </button>
        <button id="prev" className="sliderButtons">
          <Image src={SvgImages.rightArrow} />
        </button>
      </div>
    </div>
  );
};

export default Carousel;
